import React, {useState} from "react";
import Input from "./Input";
import FourDigitPin from "./FourDigitPin";
import Spinner from "./irisComponent/Spinner";

const API_URL =
  "https://60zk97leie.execute-api.ap-southeast-1.amazonaws.com/dev/AWSIrisEmailAuth";

const LoginCard = () => {
  const [inputFields, setInputFields] = useState({
    email: "",
  });
  const [responseObject, setResponseObject] = useState({
    message: "",
    pin: null,
    error: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target;
    setInputFields((prev) => ({...prev, [name]: value}));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({email: inputFields.email}),
      });
      const data = await res.json();

      setResponseObject(data);
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container-page">
      {!responseObject?.pin ? (
        <div className="login-main-content">
          <h2 className="title">
            Welcome to iCXeed's <br />
            AWS Partner Profile
          </h2>
          <p className="subtitle">
            Meet iRis: Your on-demand digital concierge, purpose-built for AWS.
          </p>
          <form onSubmit={handleSubmit}>
            <Input
              type="email"
              placeholder=""
              className="input"
              label="Enter Your AWS Email Address"
              name="email"
              value={inputFields.email}
              onChange={handleChange}
              disabled={loading}
            />

            <button
              type="submit"
              disabled={loading}
              className={`bg-cyan-500 text-black font-medium py-3 rounded-full transition ${
                loading ? "opacity-50 cursor-not-allowed" : "hover:bg-cyan-400"
              }`}>
              {loading ? (
                <Spinner variant="small-spinner" alignSpin="center-spinner" />
              ) : (
                "Continue"
              )}
            </button>
            {responseObject?.error && (
              <p className="error-message-blk">{responseObject?.error}</p>
            )}
          </form>
        </div>
      ) : (
        <FourDigitPin
          responseObject={responseObject}
          email={inputFields.email}
        />
      )}
      <p className="powered-by-blk mt-6 text-gray-400 text-xs">
        Powered By: <span className="font-semibold text-white">iCXeed</span>
      </p>
    </div>
  );
};

export default LoginCard;
